// Detecta si el video cargado por el admin es un link de YouTube/Vimeo (para embeber via iframe)
// o una URL directa de archivo (Blob/CDN, servida con <video>).
export const getVideoEmbed = (url) => {
    if (!url) return null;

    const youtubeMatch = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/
    );
    if (youtubeMatch) {
        return { type: 'iframe', src: `https://www.youtube.com/embed/${youtubeMatch[1]}` };
    }

    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
        return { type: 'iframe', src: `https://player.vimeo.com/video/${vimeoMatch[1]}` };
    }

    return { type: 'video', src: url };
};
